export default {
  error: state => state.error,
  success: state => state.success,
  loading: state => state.loading,
  expenses: state => state.expenses,
  recevablePayable: state => state.recevablePayable,
  incomeAndExpensesByMonths: state => state.incomeAndExpensesByMonths,
  providentFund: state => state.providentFund,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Dashboard/getters.js